module.exports = __webpack_public_path__ + "img/fb17.6dbedc4a.jpg";